import { render, staticRenderFns } from "./PaysolutionReturnUrl.vue?vue&type=template&id=6d8c5bcc&scoped=true&"
import script from "./PaysolutionReturnUrl.vue?vue&type=script&lang=js&"
export * from "./PaysolutionReturnUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8c5bcc",
  null
  
)

export default component.exports